import React, { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext, ThemeContext } from "../../../../auth";
import { useMediaQuery } from "react-responsive";
import Swal from "sweetalert2";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import Select from "react-select";
import { IoOpen } from "react-icons/io5";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { axiosAuth } from "../../../../api";

function ModalUbahLead({
  rowSelected,
  showEditLead,
  setShowEditLead,
  retrieveLead,
  accessToken,
}) {
  const location = useLocation();

  const { userInfo } = useContext(AuthContext);
  const { theme } = useContext(ThemeContext);
  const isMobile = useMediaQuery({ maxWidth: 736 });
  const [disabled, setDisabled] = useState(false);
  const [isSubmittingLead, setIsSubmittingLead] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [listCompany, setListCompany] = useState([]);
  const [listCustomer, setListCustomer] = useState([]);

  const retrieveCustomer = () => {
    axiosAuth
      .get(`/api/customers`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setListCustomer(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined) retrieveCustomer();
  }, [accessToken]);

  const handleClose = () => {
    setShowEditLead(false);
    setSelectedRequest(null);
  };

  const customerOptions = useMemo(
    () =>
      listCustomer.map((cust) => ({
        value: cust.id,
        label:
          cust?.title?.titleName === "Others"
            ? cust?.name
            : `${cust?.title?.titleName}. ${cust?.name}`,
      })),
    [listCustomer],
  );

  const retrieveCompany = () => {
    axiosAuth
      .get(`/api/companies`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setListCompany(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined) retrieveCompany();
  }, [accessToken]);

  const defaultValue = {
    date: rowSelected?.date || "",
    customer: rowSelected?.customer?.id || "",
    status: typeof rowSelected?.status === "number" ? rowSelected.status : "",
    companyId: rowSelected?.companyId || "",
    orderType: rowSelected?.orderType || "",
  };

  const companyOptions = useMemo(
    () =>
      listCompany.map((company) => ({
        value: company.id,
        label: "PT. " + company?.companyName,
      })),
    [listCompany],
  );

  const handleSelectCustomer = (selectedOption, setFieldValue) => {
    setFieldValue("customer", selectedOption ? selectedOption.value : null);
  };

  const handleSelectCompany = (selectedOption, setFieldValue) => {
    setFieldValue("companyId", selectedOption ? selectedOption.value : null);
  };

  const handleSelectStatus = (selectedOption, setFieldValue) => {
    setFieldValue("status", selectedOption ? selectedOption.value : null);
  };

  useEffect(() => {
    if (showEditLead && rowSelected) {
      setSelectedCustomer(
        customerOptions.find(
          (option) => option.value === rowSelected?.customer?.id,
        ) || null,
      );
    }
  }, [showEditLead, rowSelected, customerOptions]);

  const requestOptions = [
    {
      value: "penjualan",
      label: "Penjualan",
    },
    {
      value: "sewa",
      label: "Sewa",
    },
  ];

  const handleSelectRequest = (selectedOption, setFieldValue) => {
    setFieldValue("orderType", selectedOption ? selectedOption.value : null);
  };

  const [pcpData, setPcpData] = useState({});

  const retrievePCP = () => {
    axiosAuth
      .get(
        rowSelected?.orderType === "penjualan"
          ? `/api/pcp?leadId=${rowSelected?.id}`
          : `/api/pcp/sewa?leadId=${rowSelected?.id}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((res) => {
        setPcpData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (rowSelected?.id !== undefined) retrievePCP();
  }, [rowSelected?.id]);

  const leadStatusOptions = [
    { value: 10, label: "Perkenalan - 10%" },
    { value: 25, label: "Info Kebutuhan - 25%" },
    { value: 50, label: "Buat PCP - 50%" },
    { value: 75, label: "Buat SPH - 75%" },
    { value: 100, label: "Terima PO - 100%" },
    { value: 0, label: "Gagal - 0%" },
  ];

  const filteredLeadOptions = leadStatusOptions.filter((option) => {
    const isStatusAllowed =
      option.value == 0 || option.value >= rowSelected?.status;
    const isHundredAllowed = option.value != 100 || pcpData;
    return isStatusAllowed && isHundredAllowed;
  });

  const handleSubmitLead = async (values) => {
    setIsSubmittingLead(true);
    setDisabled(true);

    const dataLead = {
      orderType: selectedRequest?.value,
      ...values,
    };

    try {
      if (values?.status == 100) {
        const dataUpload = { file: uploadFile };
        try {
          const response = await axiosAuth.post(
            rowSelected?.orderType === "penjualan"
              ? `/api/upload/pcp/${pcpData?.id}`
              : `/api/upload/pcpSewa/${pcpData?.id}`,
            dataUpload,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
                withCredentials: true,
                Authorization: `Bearer ${accessToken}`,
              },
            },
          );
        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat mengupload dokumen, silahkan coba kembali!",
          });
          // STOP the function if upload fails
          setIsSubmittingLead(false);
          setDisabled(false);
          return;
        }
      }

      // Only reach here if upload succeeds or status !== 100
      const response = await axiosAuth.put(
        `/api/leads/${rowSelected?.id}`,
        dataLead,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      handleClose();

      Swal.fire({
        icon: "success",
        title: "Berhasil mengupdate Lead",
        showConfirmButton: true,
      });

      retrieveLead();
    } catch (err) {
      console.error(err);

      if (err.response?.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `${err.response?.data.message}`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mengupdate Lead",
        });
      }
    } finally {
      setIsSubmittingLead(false);
      setDisabled(false);
    }
  };

  const formStyles = {
    label: {
      fontFamily: "Poppins-Medium",
      color: theme === "light" ? "#FFFFFF" : "#222222",
    },
    input: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      minHeight: "50px",
      borderColor: "#ced4da",
      opacity: rowSelected?.pcpCreated ? 0.5 : 1,
      background: rowSelected?.pcpCreated
        ? theme === "light"
          ? "#212529"
          : "#FFFFFF"
        : theme === "light"
          ? "#FFFFFF"
          : "#212529",
    },
    input2: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      minHeight: "50px",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
  };

  const formStyles2 = {
    label: {
      fontFamily: "Poppins-Medium",
      color: theme === "light" ? "#FFFFFF" : "#222222",
    },
    input: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      minHeight: "50px",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
    inputFile: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
  };

  const selectStyles = {
    control: (cityided, state) => ({
      ...cityided,
      minHeight: "50px",
      width: "100%", // make sure it stretches
      border: state.isFocused ? "1px solid #80bdff" : "1px solid #ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.3rem rgba(0, 123, 255, 0.25)"
        : null,
      "&:hover": {
        borderColor: "#80bdff",
      },
      textAlign: "left",
      fontFamily: "Poppins-Regular",
      background: rowSelected?.pcpCreated
        ? theme === "light"
          ? "#212529"
          : "#FFFFFF"
        : theme === "light"
          ? "#FFFFFF"
          : "#212529",
      opacity: rowSelected?.pcpCreated ? 0.5 : 1,
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#333",
      background: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#f5f5f5"
          : "#fff",
      fontFamily: "Poppins-Regular",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
    input: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
  };

  const selectStyles2 = {
    control: (cityided, state) => ({
      ...cityided,
      minHeight: "50px",
      width: "100%", // make sure it stretches
      border: state.isFocused ? "1px solid #80bdff" : "1px solid #ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.3rem rgba(0, 123, 255, 0.25)"
        : null,
      "&:hover": {
        borderColor: "#80bdff",
      },
      textAlign: "left",
      fontFamily: "Poppins-Regular",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#333",
      background: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#f5f5f5"
          : "#fff",
      fontFamily: "Poppins-Regular",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
    input: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
  };

  const selectStyles3 = {
    control: (cityided, state) => ({
      ...cityided,
      minHeight: "50px",
      width: "100%", // make sure it stretches
      border: state.isFocused ? "1px solid #80bdff" : "1px solid #ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.3rem rgba(0, 123, 255, 0.25)"
        : null,
      "&:hover": {
        borderColor: "#80bdff",
      },
      textAlign: "left",
      fontFamily: "Poppins-Regular",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#333",
      background: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#f5f5f5"
          : "#fff",
      fontFamily: "Poppins-Regular",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
    input: (provided) => ({
      ...provided,
      color: theme === "light" ? "#FFFFFF" : "#222",
      fontFamily: "Poppins-Regular",
    }),
  };

  const navigate = useNavigate();

  const pcpButton = (rowSelected) => {
    if (location?.pathname.startsWith("/sales-lead/")) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "User belum membuat PCP",
      });
    } else {
      navigate(
        rowSelected?.orderType === "penjualan"
          ? "/pcp-penjualan/"
          : "/pcp-sewa/",
        { state: { data: rowSelected } },
      );
    }
  };

  const [uploadFile, setUploadFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        // 5MB limit
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "The selected file exceeds the 5MB size limit. Please choose a smaller file.",
        });
        setUploadFile(null);
        return;
      }
      setUploadFile(file);
    }
  };

  //Tambah menggunakan location-pathname sales-lead
  const updatePcp = (rowSelected) => {
    if (
      rowSelected?.status === 100 ||
      location.pathname.startsWith("/sales-lead")
    ) {
      navigate(`/pcp-detail/${rowSelected.id}`, {
        state: { data: rowSelected },
      });
    } else {
      const path =
        rowSelected?.orderType === "penjualan"
          ? `/pcp-penjualan/${rowSelected.id}`
          : `/pcp-sewa/${rowSelected.id}`;
      navigate(path);
    }
  };

  const fileViewer = async () => {
    try {
      const response = await axiosAuth.get(
        `/api/view/${rowSelected?.orderType == "penjualan" ? "pcp" : "pcpSewa"}/${pcpData?.id}`,
        {
          responseType: "blob", // Important to treat response as blob
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          withCredentials: true, // This should be outside headers
        },
      );

      const blobUrl = window.URL.createObjectURL(response.data);
      window.open(blobUrl, "_blank");
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Oops...!",
        text: `Gagal memuat dokumen, coba beberapa saat lagi!`,
      });
    }
  };

  const [showModalSPH, setShowModalSPH] = useState(false);
  const [sphGenerate, setSphGenerate] = useState(false);
  const [sphCreatedAt, setSphCreatedAt] = useState("");

  const sphButton = () => {
    setShowModalSPH(true);
  };

  const sphButtonView = async (rowSelected) => {
    if (!isMobile) {
      try {
        const response = await axiosAuth.post(
          `/api/leads/sph/${rowSelected?.id}`,
          {},
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              withCredentials: true,
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        navigate("/sph/", {
          state: { data: rowSelected, sphData: response?.data?.data },
        });

        setSphGenerate(false);
        setDisabled(false);
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat membuat SPH",
        });
        setSphGenerate(false);
        setDisabled(false);
      } finally {
        setSphGenerate(false);
        setDisabled(false);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pembuatan SPH hanya bisa menggunakan Laptop atau Desktop!",
      });
    }
  };

  const handleCloseSPH = () => {
    setShowModalSPH(false);
    setSphCreatedAt("");
  };

  const handleSubmitSPH = async (event) => {
    if (!isMobile) {
      event.preventDefault();
      setSphGenerate(true);
      setDisabled(true);

      const dateOnly = sphCreatedAt; // e.g., "2025-05-08"
      const now = new Date();

      const fullDateTime = new Date(dateOnly);
      fullDateTime.setHours(now.getHours());
      fullDateTime.setMinutes(now.getMinutes());
      fullDateTime.setSeconds(30); // <-- explicitly set to 30

      const dataSPH = {
        sphCreatedAt: fullDateTime.toISOString(),
      };

      try {
        const response = await axiosAuth.post(
          `/api/leads/sph/${rowSelected?.id}`,
          dataSPH,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              withCredentials: true,
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        navigate("/sph/", {
          state: { data: rowSelected, sphData: response?.data?.data },
        });

        setSphGenerate(false);
        handleCloseSPH();
        setDisabled(false);
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat membuat SPH",
        });
        setSphGenerate(false);
        setDisabled(false);
      } finally {
        setSphGenerate(false);
        handleCloseSPH();
        setDisabled(false);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pembuatan SPH hanya bisa menggunakan Laptop atau Desktop!",
      });
    }
  };

  const [discussionContent, setDiscussionContent] = useState();
  const [discussionsData, setDiscussionData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true); // Only for first load
  const [loadingDiscussion, setLoadingDiscussion] = useState(false);

  // const retrieveDiscussion = () => {
  //     setLoadingDiscussion(true);
  //     axiosAuth.get(`/api/discussions?leadId=${rowSelected?.id}`,
  //         {
  //             headers: {
  //                 'Access-Control-Allow-Origin': '*',
  //                 'Content-Type': 'application/json',
  //                 withCredentials: true,
  //                 Authorization: `Bearer ${accessToken}`,
  //             },
  //         })
  //         .then(res => {
  //             setDiscussionData(res.data.data);

  //             setLoadingDiscussion(false);
  //         }).catch(err => {
  //             console.error(err);
  //             Swal.fire({
  //                 icon: 'error',
  //                 title: 'Oops...',
  //                 text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
  //             });
  //             setLoadingDiscussion(false);
  //         });
  // };

  // // Initial fetch when dependencies are ready
  // useEffect(() => {
  //     if (accessToken && rowSelected?.id) retrieveDiscussion();
  // }, [accessToken, rowSelected?.id]);

  // // Auto fetch when the minute changes
  // useEffect(() => {
  //     let lastMinute = new Date().getMinutes();

  //     const intervalId = setInterval(() => {
  //         const now = new Date();
  //         const currentMinute = now.getMinutes();

  //         if (currentMinute !== lastMinute) {
  //             lastMinute = currentMinute;

  //             if (accessToken && rowSelected?.id) {
  //                 retrieveDiscussion();
  //             }
  //         }
  //     }, 1000); // check every second

  //     return () => clearInterval(intervalId);
  // }, [accessToken, rowSelected?.id]);

  // First-time fetch
  // ✅ Reusable function with a flag
  const retrieveDiscussion = (isInitial = false) => {
    if (isInitial) {
      setInitialLoading(true);
    } else {
      setLoadingDiscussion(true);
    }

    axiosAuth
      .get(`/api/discussions?leadId=${rowSelected?.id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setDiscussionData(res.data.data);
      })
      .catch((err) => {
        console.error(err);
        if (isInitial) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Gagal memuat data, coba kembali beberapa saat lagi!",
          });
        }
      })
      .finally(() => {
        if (isInitial) {
          setInitialLoading(false);
        } else {
          setLoadingDiscussion(false);
        }
      });
  };

  // ✅ Fetch once when modal opens
  useEffect(() => {
    if (accessToken && rowSelected?.id) {
      retrieveDiscussion(true); // show loading spinner
    }
  }, [accessToken, rowSelected?.id]);

  // ✅ Silent refresh every minute
  useEffect(() => {
    let lastMinute = new Date().getMinutes();
    const intervalId = setInterval(() => {
      const now = new Date();
      const currentMinute = now.getMinutes();

      if (currentMinute !== lastMinute) {
        lastMinute = currentMinute;
        if (accessToken && rowSelected?.id) {
          retrieveDiscussion(false); // no loading spinner
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [accessToken, rowSelected?.id]);

  const [isSubmittingDiscussion, setIsSubmittingDiscussion] = useState(false);

  const handleSubmitDiscussion = async (event) => {
    event.preventDefault();
    setIsSubmittingDiscussion(true);
    setDisabled(true);

    const dataComment = {
      content: discussionContent,
      userId: userInfo?.id,
      leadId: rowSelected?.id,
    };

    try {
      const responseDiscussion = await axiosAuth.post(
        `/api/discussions`,
        dataComment,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      retrieveDiscussion(false);
      setDiscussionContent("");
      setIsSubmittingDiscussion(false);
      setDisabled(false);
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Terjadi kesalahan saat menambahkan Komentar",
      });

      setIsSubmittingDiscussion(false);
      setDisabled(false);
    } finally {
      setIsSubmittingDiscussion(false);
      setDisabled(false);
    }
  };

  const modalStyle = {
    center: {
      position: "absolute",
      zIndex: 1200, // ensure it's above the backdrop
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <Modal
      show={showEditLead}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="xl"
      centered
      data-bs-theme={theme === "light" ? "dark" : ""}
    >
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            fontFamily: "Poppins-Medium",
            color: theme === "light" ? "#FFFFFF" : "#222222",
          }}
        >
          {location.pathname == "/lead" ? "Update Lead" : "Detail Lead"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="d-flex align-items-stretch">
          <Col
            xs={12}
            md={6}
            lg={6}
            style={{
              borderRight: isMobile ? "" : "1px solid #acacac",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Formik
              initialValues={defaultValue}
              enableReinitialize={true}
              onSubmit={handleSubmitLead}
            >
              {({ handleSubmit, handleChange, values, setFieldValue }) => (
                <Form onSubmit={handleSubmit} className="mx-2">
                  {location.pathname == "/lead" ? (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="date">
                        Tanggal*
                      </Form.Label>
                      <Form.Control
                        id="date"
                        type="date"
                        value={values.date}
                        onChange={handleChange("date")}
                        required
                        style={
                          rowSelected?.pcpCreated === true
                            ? formStyles.input
                            : formStyles2.input
                        }
                        disabled={
                          rowSelected?.pcpCreated === true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="date">
                        Tanggal*
                      </Form.Label>
                      <Form.Control
                        id="date"
                        type="date"
                        value={values.date}
                        onChange={handleChange("date")}
                        required
                        style={formStyles2.input}
                        disabled={
                          true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  )}
                  {location.pathname == "/lead" ? (
                    <>
                      <Form.Label style={formStyles.label} htmlFor="customer">
                        Customer*
                      </Form.Label>
                      <InputGroup className="mb-3">
                        <div style={{ flex: 1 }}>
                          <Select
                            id="customer"
                            options={customerOptions}
                            required
                            value={
                              customerOptions.find(
                                (option) => option.value === values.customer,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleSelectCustomer(
                                selectedOption,
                                setFieldValue,
                              )
                            }
                            styles={
                              rowSelected?.pcpCreated === true
                                ? selectStyles
                                : selectStyles3
                            }
                            placeholder="Pilih Customer"
                            isDisabled={
                              rowSelected?.pcpCreated === true ||
                              location.pathname.startsWith("/sales-lead") ||
                              rowSelected?.status == 0
                            }
                          />
                        </div>
                      </InputGroup>
                    </>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="customer">
                        Customer*
                      </Form.Label>
                      <Select
                        id="customer"
                        options={customerOptions}
                        required
                        value={
                          customerOptions.find(
                            (option) => option.value === values.customer,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectCustomer(selectedOption, setFieldValue)
                        }
                        styles={selectStyles3}
                        placeholder="Pilih Customer"
                        isDisabled={
                          true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  )}
                  {location.pathname == "/lead" ? (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="company">
                        Perusahaan*
                      </Form.Label>
                      <Select
                        id="company"
                        options={companyOptions}
                        value={
                          companyOptions.find(
                            (option) => option.value === values.companyId,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectCompany(selectedOption, setFieldValue)
                        }
                        styles={
                          rowSelected?.pcpCreated === true
                            ? selectStyles
                            : selectStyles3
                        }
                        isDisabled={
                          rowSelected?.pcpCreated === true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="company">
                        Perusahaan*
                      </Form.Label>
                      <Select
                        id="company"
                        options={companyOptions}
                        value={
                          companyOptions.find(
                            (option) => option.value === values.companyId,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectCompany(selectedOption, setFieldValue)
                        }
                        styles={selectStyles3}
                        isDisabled={
                          true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  )}
                  {location.pathname == "/lead" ||
                  location.pathname == "/sales" ||
                  location.pathname.startsWith("/sales-lead") ||
                  location.pathname.startsWith("/dashboard-sales") ? (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="request">
                        Tipe Transaksi
                      </Form.Label>
                      <Select
                        id="request"
                        options={requestOptions}
                        value={
                          requestOptions.find(
                            (option) => option.value === values.orderType,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectRequest(selectedOption, setFieldValue)
                        }
                        styles={
                          rowSelected?.pcpCreated === true
                            ? location.pathname.startsWith("/sales-lead") ||
                              location.pathname.startsWith(
                                "/dashboard-sales",
                              ) ||
                              location.pathname === "/sales"
                              ? selectStyles3
                              : selectStyles
                            : selectStyles3
                        }
                        isDisabled={
                          rowSelected?.pcpCreated === true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                      <Row>
                        {rowSelected?.status >= 40 ? (
                          <>
                            <Col xs={2} className="text-start">
                              <Button
                                className="my-3 me-2"
                                variant="btn"
                                onClick={() =>
                                  rowSelected?.pcpCreated === true
                                    ? updatePcp(rowSelected)
                                    : pcpButton(rowSelected)
                                }
                                style={{
                                  backgroundColor: "#809D3C",
                                  color: "white",
                                  fontFamily: "Poppins-Regular",
                                  border: "none",
                                }}
                                disabled={!rowSelected.orderType || disabled}
                              >
                                PCP
                              </Button>
                            </Col>
                            {!rowSelected.orderType ? (
                              <Col xs={10} className="text start my-auto">
                                <small
                                  style={{
                                    marginBottom: "0px",
                                    fontFamily: "Poppins-Light",
                                    color: "red",
                                  }}
                                >
                                  *Masukkan tipe transaksi dahulu
                                </small>
                              </Col>
                            ) : (
                              <></>
                            )}
                            <Col xs={3} className="text-start my-auto">
                              {rowSelected?.status >= 60 ? (
                                <>
                                  {sphGenerate ? (
                                    <Button
                                      style={{
                                        backgroundColor: "#4635B1",
                                        border: "none",
                                        minWidth: "55px",
                                      }}
                                      variant="btn"
                                      disabled
                                    >
                                      <Spinner animation="border" size="sm" />
                                    </Button>
                                  ) : (
                                    <Button
                                      className="my-3 me-2"
                                      variant="btn"
                                      onClick={
                                        userInfo?.role?.roleName !== "Sales"
                                          ? () => sphButtonView(rowSelected)
                                          : () => sphButton(rowSelected)
                                      }
                                      style={{
                                        backgroundColor: "#4635B1",
                                        color: "white",
                                        fontFamily: "Poppins-Regular",
                                        border: "none",
                                        minWidth: "55px",
                                      }}
                                      disabled={
                                        disabled ||
                                        pcpData?.status === "pending"
                                      }
                                    >
                                      {userInfo?.role?.roleName !== "Sales"
                                        ? "Lihat SPH"
                                        : "SPH"}
                                    </Button>
                                  )}
                                </>
                              ) : null}
                            </Col>
                          </>
                        ) : null}
                      </Row>
                    </Form.Group>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="request">
                        Tipe Transaksi
                      </Form.Label>
                      <Select
                        id="request"
                        options={requestOptions}
                        value={
                          requestOptions.find(
                            (option) => option.value === values.orderType,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectRequest(selectedOption, setFieldValue)
                        }
                        styles={selectStyles3}
                        isDisabled={
                          true ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  )}
                  {location.pathname == "/lead" ? (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="status">
                        Status Lead*
                      </Form.Label>
                      <Select
                        id="status"
                        options={filteredLeadOptions}
                        required
                        value={
                          filteredLeadOptions.find(
                            (option) => option.value === values.status,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectStatus(selectedOption, setFieldValue)
                        }
                        styles={
                          rowSelected?.status == 100
                            ? selectStyles
                            : selectStyles2
                        }
                        placeholder="Pilih Status Lead"
                        isDisabled={
                          disabled ||
                          rowSelected?.status == 100 ||
                          location.pathname.startsWith("/sales-lead") ||
                          rowSelected?.status == 0
                        }
                      />
                    </Form.Group>
                  ) : (
                    <Form.Group className="mb-3">
                      <Form.Label style={formStyles.label} htmlFor="status">
                        Status Lead*
                      </Form.Label>
                      <Select
                        id="status"
                        options={filteredLeadOptions}
                        required
                        value={
                          filteredLeadOptions.find(
                            (option) => option.value === values.status,
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSelectStatus(selectedOption, setFieldValue)
                        }
                        styles={selectStyles2}
                        placeholder="Pilih Status Lead"
                        isDisabled={true}
                      />
                    </Form.Group>
                  )}

                  {location.pathname == "/lead" && values?.status >= 80 ? (
                    <>
                      {rowSelected?.status == 100 ? (
                        <></>
                      ) : (
                        <Form.Group className="mb-3">
                          <Form.Label style={formStyles.label} htmlFor="filePo">
                            File PO*
                          </Form.Label>
                          <Form.Control
                            id="filePo"
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            required={rowSelected?.document == null}
                            style={formStyles2.inputFile}
                            disabled={disabled || rowSelected?.status == 100}
                          />
                        </Form.Group>
                      )}
                    </>
                  ) : (
                    <></>
                  )}

                  {rowSelected?.document == null ? (
                    <></>
                  ) : (
                    <>
                      <Form.Label
                        style={formStyles.label}
                        htmlFor="filePoTarik"
                      >
                        File PO Tersimpan*
                      </Form.Label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          id="filePoTarik"
                          type="text"
                          value={
                            rowSelected?.document
                              ? rowSelected.document.split("/").pop()
                              : ""
                          }
                          readOnly
                          style={formStyles.input2}
                        />
                        <Button
                          style={{
                            backgroundColor:
                              theme === "light" ? "#12B3ED" : "#006CB8",
                            border: "none",
                          }}
                          onClick={fileViewer}
                        >
                          <IoOpen
                            size={25}
                            color={theme === "light" ? "#212529" : "#FFFFFF"}
                          />
                        </Button>
                      </InputGroup>
                    </>
                  )}
                  {location.pathname == "/lead" ? (
                    <div className="d-grid gap-2 mb-2 mt-3">
                      {isSubmittingLead ? (
                        <Button
                          id={
                            theme === "light"
                              ? "actionButtonModalDark"
                              : "actionButtonModalLight"
                          }
                          variant="btn"
                          disabled
                        >
                          <Spinner animation="border" size="sm" />
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          id={
                            theme === "light"
                              ? "actionButtonModalDark"
                              : "actionButtonModalLight"
                          }
                          variant="btn"
                          disabled={
                            disabled ||
                            (values?.status >= 80 &&
                              !uploadFile &&
                              rowSelected?.document == null)
                          }
                        >
                          Simpan
                        </Button>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Form>
              )}
            </Formik>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              className="mx-2"
              style={{ flex: 1, display: "flex", flexDirection: "column" }}
            >
              {/* discussion content */}
              <div style={{ flex: 1, overflowY: "auto" }}>
                {initialLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <Spinner
                      animation="border"
                      style={{
                        color: theme === "light" ? "#F3C623" : "#2f4b7c",
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    {discussionsData?.length === 0 ? (
                      <div
                        style={{
                          minHeight: "24.7rem",
                          flex: "1",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          className="text-muted"
                          style={{
                            fontStyle: "italic",
                            fontFamily: "Poppins-Regular",
                          }}
                        >
                          Belum ada diskusi.
                        </p>
                      </div>
                    ) : (
                      <div
                        className="mb-4 p-3"
                        style={{
                          maxHeight: "28rem",
                          overflowY: "auto",
                          backgroundColor: "#e5ddd5",
                          borderRadius: "10px",
                          border: "1px solid #dee2e6",
                        }}
                      >
                        {(() => {
                          const sortedData = [...discussionsData].sort(
                            (a, b) => a.id - b.id,
                          );
                          let lastDateShown = "";

                          return sortedData.map((data, index) => {
                            const isCurrentUser =
                              data.firstName === userInfo?.firstName &&
                              data.lastName === userInfo?.lastName;

                            const createdAt = new Date(data.createdAt);
                            const now = new Date();
                            const dateKey = createdAt
                              .toISOString()
                              .split("T")[0];
                            const todayKey = now.toISOString().split("T")[0];

                            const yesterday = new Date(now);
                            yesterday.setDate(now.getDate() - 1);
                            const yesterdayKey = yesterday
                              .toISOString()
                              .split("T")[0];

                            let dateLabel = "";
                            if (dateKey === todayKey) {
                              dateLabel = "Hari ini";
                            } else if (dateKey === yesterdayKey) {
                              dateLabel = "Kemarin";
                            } else {
                              dateLabel = createdAt.toLocaleDateString(
                                "id-ID",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                },
                              );
                            }

                            const showDateLabel = lastDateShown !== dateKey;
                            lastDateShown = dateKey;

                            return (
                              <React.Fragment key={index}>
                                {showDateLabel && (
                                  <div
                                    className="text-center my-3"
                                    style={{ fontSize: "13px", opacity: 0.7 }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: "#212529",
                                        borderRadius: "10px",
                                        color: "white",
                                        padding: "4px 10px",
                                        fontFamily: "Poppins-Regular",
                                      }}
                                    >
                                      {dateLabel}
                                    </span>
                                  </div>
                                )}

                                <div
                                  className={`d-flex mb-3 ${
                                    isCurrentUser
                                      ? "justify-content-end"
                                      : "justify-content-start"
                                  }`}
                                >
                                  <div
                                    style={{
                                      backgroundColor: isCurrentUser
                                        ? "#d9fdd3"
                                        : "#ffffff",
                                      color: "#000",
                                      padding: "10px 15px",
                                      borderRadius: "10px",
                                      maxWidth: "70%",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "#2c3e50",
                                        marginBottom: "5px",
                                        fontFamily: "Poppins-Bold",
                                      }}
                                    >
                                      {data.firstName} {data.lastName}
                                    </div>

                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontFamily: "Poppins-Regular",
                                      }}
                                    >
                                      {data.content}
                                    </div>

                                    <div
                                      style={{
                                        textAlign: "right",
                                        fontSize: "11px",
                                        color: "#666",
                                        marginTop: "4px",
                                        fontFamily: "Poppins-Light",
                                      }}
                                    >
                                      {createdAt.toLocaleTimeString("id-ID", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          });
                        })()}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* form should stay at bottom */}
              <Form onSubmit={handleSubmitDiscussion}>
                <Form.Group className="mb-3">
                  <Form.Label style={formStyles.label} htmlFor="content">
                    Komentar*
                  </Form.Label>
                  <Form.Control
                    id="content"
                    type="text"
                    onChange={(e) => setDiscussionContent(e.target.value)}
                    value={discussionContent}
                    required
                    style={formStyles.input2}
                    placeholder="Tuliskan komentar"
                  />
                </Form.Group>
                <div className="d-grid gap-2 my-2">
                  {isSubmittingDiscussion ? (
                    <Button
                      id={
                        theme === "light"
                          ? "actionButtonModalDark"
                          : "actionButtonModalLight"
                      }
                      variant="btn"
                      disabled
                    >
                      <Spinner animation="border" size="sm" />
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      id={
                        theme === "light"
                          ? "actionButtonModalDark"
                          : "actionButtonModalLight"
                      }
                      variant="btn"
                      disabled={disabled || !discussionContent}
                    >
                      Kirim Komentar
                    </Button>
                  )}
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Modal.Body>

      {/* Modal SPH */}
      <Modal
        show={showModalSPH}
        onHide={handleCloseSPH}
        backdrop="static"
        keyboard={false}
        size="sm"
        centered
        backdropClassName="dark-backdrop"
        style={modalStyle.center}
        data-bs-theme={theme === "light" ? "dark" : ""}
      >
        <Modal.Header closeButton>
          <Modal.Title style={formStyles.label}>Pembuatan SPH</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitSPH}>
            <Form.Group className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="date">
                Tanggal SPH*
              </Form.Label>
              <Form.Control
                id="date"
                type="date"
                onChange={(e) => setSphCreatedAt(e.target.value)}
                value={sphCreatedAt}
                required
                max={today}
                style={formStyles.input2}
              />
            </Form.Group>
            <div className="d-grid gap-2 my-2">
              {isSubmittingDiscussion ? (
                <Button
                  id={
                    theme === "light"
                      ? "actionButtonModalDark"
                      : "actionButtonModalLight"
                  }
                  variant="btn"
                  disabled
                >
                  <Spinner animation="border" size="sm" />
                </Button>
              ) : (
                <Button
                  type="submit"
                  id={
                    theme === "light"
                      ? "actionButtonModalDark"
                      : "actionButtonModalLight"
                  }
                  variant="btn"
                  disabled={disabled || !sphCreatedAt}
                >
                  Buat
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Modal SPH */}
    </Modal>
  );
}

export default ModalUbahLead;
